import { Close } from '@mui/icons-material';
import { IconButton, Snackbar, SnackbarCloseReason } from '@mui/material';
import dayjs from 'dayjs';
import React, { useState } from 'react';

import { Trial } from '@/domain/auth/entities/user.entity';
import { FSSecondaryButton } from '@/ui/components/button/FSSecondaryButton';
import { translate } from '@/ui/i18n';

export function TrialMessageBar({
  userTrial,
  onClickGoPrenium,
}: {
  userTrial: Trial;
  onClickGoPrenium: () => void;
}) {
  const [open, setOpen] = useState(true);

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      sx={{ marginLeft: 8 }}
      onClose={handleClose}
      message={translate('License.TrialOn', {
        day: dayjs(userTrial.endTime).diff(dayjs(), 'd'),
      })}
      action={
        <React.Fragment>
          <FSSecondaryButton onClick={onClickGoPrenium}>
            {translate('License.TrialOnAction')}
          </FSSecondaryButton>
          <IconButton
            aria-label="close"
            color="inherit"
            sx={{ p: 0.5 }}
            onClick={handleClose}
          >
            <Close />
          </IconButton>
        </React.Fragment>
      }
    />
  );
}
